import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ApiPathsService} from "../../api-paths.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Magazzino} from "../_Models/magazzino";
import { environment } from 'src/environments/environment';
import {CdkDragDrop, moveItemInArray} from "@angular/cdk/drag-drop";
import {IDropdownSettings} from "../../../LibrerieCustom/MultiselectDropdown";

@Component({
  selector: 'app-movimentazioni',
  templateUrl: './movimentazioni.component.html',
  styleUrls: ['./movimentazioni.component.scss']
})
export class MovimentazioniComponent implements OnInit {
  environment = environment;
  @Input() firstListType: string;
  @Input() secondListType: string;
  @Input() firstList: Magazzino[] = [];
  @Input() secondList: Magazzino[] = [];
  firstMagazzino: Magazzino;
  prodotti = [];
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    allowSearchFilter: true,
    singleOutput: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'nome',
  };
  constructor(
    private route: ActivatedRoute,
    private apiPaths: ApiPathsService,
    private ngbModal: NgbModal,
  ) { }
  ngOnInit(): void {
    if(!this.firstListType)
      this.route.params.subscribe(data => {
        this.firstListType = data['type'];
        this.secondListType = data['type2'];
        this.Refresh();
      });
    this.Refresh();
  }
  Refresh() {
    this.apiPaths.ClassicPost(`/prodotti/${this.firstListType}/list`, {page:0, size: 10}).subscribe(data => {
      this.firstList = data.data;
      if(data.data?.length == 1) {
        this.firstMagazzino = data.data[0];
        this.apiPaths.ClassicPost(`/prodotti/list`, {page:0, size: 10, tipo: this.environment['Magazzino']['idProdotto'], magazzino: this.firstMagazzino?.id}).subscribe(data => {
          this.prodotti = data.data;
        });
      }
      if(data.data?.length ==0)
        this.apiPaths.ClassicPost(`/prodotti/list`, {page:0, size: 10, tipo: this.environment['Magazzino']['idProdotto'], magazzino: null}).subscribe(data => {
          this.prodotti = data.data;
        });
      if(!this.secondListType) {
        this.secondList = this.firstList;
      }
    });
    if(this.secondListType)
    this.apiPaths.ClassicPost(`/prodotti/${this.secondListType}/list`, {page:0, size: 10}).subscribe(data => {
        this.secondList = data.data?.map(z => {z.prodotti = []; return z});
        console.log("Furgoni: ", this.secondList);
    });
  }

  onMagazzinoSelect($event: any) {
    if($event)
    this.apiPaths.ClassicPost(`/prodotti/list`, {page:0, size: 10, tipo: this.environment['Magazzino']['idProdotto'], magazzino: $event?.id}).subscribe(data => {
      this.prodotti = data.data;
    }, error=> this.firstMagazzino = null);
  }

  drop(event: CdkDragDrop<any[], any>, magazzino?: Magazzino) {
    console.log(event)
    console.log(magazzino)
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      var prev = event.previousContainer.data[event.previousIndex]
      var idProdottogiaInserito = magazzino?.prodotti?.findIndex(x=> x.id == prev.id) ?? -1
      /*transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);*/
      if(magazzino && idProdottogiaInserito < 0){
        var prodotto = Object.assign({}, event.previousContainer.data[event.previousIndex]);
        prodotto.qta = 1;
        magazzino.prodotti?.push( prodotto)
        console.log(magazzino.nome ?? magazzino.targa, magazzino.prodotti);
      }else if (magazzino){
        magazzino.prodotti[idProdottogiaInserito].qta += 1;
        console.log(magazzino.nome ?? magazzino.targa, magazzino.prodotti);
      }
      else{

        var furgone = this.secondList.find(x=>x.prodotti == event.previousContainer.data);
        var toDelete = furgone.prodotti?.findIndex(x=> x.id == prev.id);
        furgone.prodotti?.splice(toDelete, 1);

      }
    }

  }


  Salva() {
    var List = [];
    this.secondList.forEach(furgone =>
      List = [...List, ...furgone.prodotti?.map(x=> ({prodotto_id: x.id, qta: x.qta, motivo: "Carico furgone", mag_ingresso_id: furgone.id, mag_uscita_id: this.firstMagazzino?.id})) ?? []]
    );
    this.apiPaths.ClassicPost(`/prodotti/magazzini/movimentazioni/add`, List).subscribe(data => {
      this.Refresh();
    });
  }

  quantityChange(prodotto: any, item: Magazzino, event: any) {
    console.log(event)
    var id = this.prodotti?.findIndex(x=> x.id == prodotto.id);
  }

  spostati(item: any): number {
    var quantita = 0;
    this.secondList.forEach(furgone => {
      quantita += furgone.prodotti?.find(x=> x.id == item.id)?.qta ?? 0;
    });
    return quantita;
  }
}
